import { r as t } from "./react-is-fdabd8df.js";
var r = t(), a = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, p = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, e = {};
e[r.ForwardRef] = a;
e[r.Memo] = p;
